import { Box, BoxProps, Toolbar } from '@mui/material';
import { Outlet } from 'react-router-dom';
import Navbar from './Navbar';

const BaseLayout = (props: BoxProps) => {
  return (
    <Box
      {...props}
      overflow={'auto'}
      display={'flex'}
      flexDirection={'column'}
      flex={1}
      bgcolor={'#f2f2f2'}
      minHeight={'100vh'}
    >
      <Navbar />
      <Toolbar />
      <Outlet />
    </Box>
  );
};

export default BaseLayout;
